<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Products" title="Speed Governors" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list page-subtitle">
								<div class="row">
									<div class="col-md-12">
										<router-link :to="{ name: 'products' }" class="btn btn-primary float-end">Back</router-link>
									</div>
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-10 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<!-- <select class="form-control" v-model="listing_length" @change="fetchUsers()"> -->
											<select class="form-select" v-model="listing_length" @change="fetchSpeedGoverners()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-2 mt-2">
										<input type="text" class="form-control ms-1" placeholder="Search" v-model="keyword" @keyup="fetchSpeedGoverners()"/>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>  
                                            <th>Vehicle Make</th>
											<th>Vehicle Model</th>
											<th>Speed</th> 
											<th>Test Report No</th>
											<th>TAC Number</th>
											<th>COP Number</th>
											<th>SG Model</th>
											<th>Company Name</th>
											<th>SLD Type</th>
                                        </tr>
									</thead>
									<tbody v-if="Boolean(speedGovernerList.length)">
										<tr align="center" v-for="(product, index) in speedGovernerList" :key="product.id">
                                            <td>{{ (from - 1) + index+1 }}</td>
                                            <td>
												{{ product.vehicle_make }}
											</td>
											<td>
												{{ product.vehicle_model }}
											</td>
											<td>{{ product.speed }}</td>
											<td>{{ product.test_report_no }}</td>
											<td>{{ product.sg_tac_number || '-' }}</td>
											<td>{{ product.cop_number || '-' }}</td>
											<td>{{ product.sg_model || '-' }}</td>
											<td>{{ product.company_name || '-' }}</td>
											<td>{{ product.sld_type || '-' }}</td>
                                        </tr>
                                    </tbody>
									<tbody v-else>
										<tr>
											<td colspan="11" class="text-center">No Speed Governors found</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<div class="row mt-2">
								<div class="col-md-6">
									<p class="text-muted mb-0">
										Showing {{ from || 0 }} to {{ to || 0 }} of {{ total || 0 }} entries
									</p>
								</div>
								<div class="col-md-6">
									<nav aria-label="Page navigation">
										<ul class="pagination justify-content-end">
											<li class="page-item" v-for="(page, index) in pagination" :key="index" :class="[{ disabled: !page.url }, { active: page.active }]">
											<a class="page-link" href="#" @click.prevent="fetchSpeedGoverners(page.url)" tabindex="-1">
												<span v-if="index === 0">Prev</span>
												<span v-else-if="index === pagination.length - 1">Next</span>
												<span v-else v-html="page.label"></span>
											</a>
											</li>
										</ul>
									</nav>
								</div>
							</div>
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script setup>
import { ref, reactive, onMounted,inject } from 'vue';
import { get } from '@/utils/api.js';
import { routes } from '@/constants/routes.js';
import Swal from '@/utils/swal';
import { useRouter } from 'vue-router';

const router = useRouter();

const keyword = ref('');
const showsearch = ref(false);
const listing_length = ref(10);
const token = ref('');
const errors = ref({});
const status = ref('');
const speedGovernerList = ref([]);
const from = ref(null);
const to = ref(null);
const total = ref(null);
const pagination = ref({})

onMounted(() => {
    fetchSpeedGoverners();
});

const fetchSpeedGoverners = (url = null) => {

    const params = {
        limit: listing_length.value,
        keyword: keyword.value,
        status: status.value
    };

    const requestUrl = url ?? routes.SpeedGoverners;

    get(requestUrl, { params }, false)
        .then((response) => {
        if (response.status === 200) {
            console.log('Speed Governors API Response:', response.data);
            
            // Handle the new API response structure
            if (response.data.success && response.data.data.speedGovernors) {
                const speedGovernorsData = response.data.data.speedGovernors;
                
                speedGovernerList.value = speedGovernorsData.data || [];
                pagination.value = speedGovernorsData.links || [];
                from.value = speedGovernorsData.from;
                to.value = speedGovernorsData.to;
                total.value = speedGovernorsData.total;
            } else {
                // Fallback for old structure
                speedGovernerList.value = response.data.data.data || [];
                pagination.value = response.data.data.links || [];
                from.value = response.data.data.from;
                to.value = response.data.data.to;
                total.value = response.data.data.total;
            }
        } else {
            Swal.fire('', response.data.message || 'Error fetching data', 'error');
        }
        })
        .catch((error) => {
        if (error.response?.status === 422) {
            Swal.fire('', error.response.data.message || 'Validation error', 'error');
        } else if (error.response?.status === 500) {
            Swal.fire('', error.response.statusText || 'Server error', 'error');
        } else if (error.response?.status === 401) {
            Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
            router.push({ name: 'login' });
        } else {
            Swal.fire('', error.response.data?.message || 'Error occured', 'error');
        }
    });
};


</script>

